module.exports = __webpack_public_path__ + "img/Photo_1_First_Canal.89647ed5.jpg";